/**
 * 모니터링의 「읽을 곳 · 저장할 곳」(2026-10-18) — 서버 /monitoring/sources 의 항목을 화면에 보이는 이름으로.
 * 「데이터소스」 를 따로 두지 않는다: 수집 저장소(내장) 또는 연결이다. 옮기지 못한 옛 데이터소스(SQLite 파일 등)는 그렇다고 표시한다.
 * 개념 정리는 서버 monitoring/sourceRef.js 머리말.
 */
export const STORE_ID = 'ds_monitoring_db';

/** 고르기 목록의 글 — t 를 받는다(모듈 스코프에서 번역하지 않는다) */
export function sourceLabel(src, t) {
    if (!src) return '';
    if (src.kind === 'store') return t('monitoring:src.store');
    if (src.kind === 'legacy') return t('monitoring:src.legacy', { name: src.name });
    return `${src.name}${src.type ? ` · ${src.type}` : ''}`;
}

/** 저장된 값이 목록에 없을 때(지운 연결 · 볼 수 없는 연결)도 고르기 상자가 비어 보이지 않게 한 줄 더한다 */
export function withCurrent(list, current, t) {
    const items = Array.isArray(list) ? list : [];
    if (!current || items.some(x => x.id === current)) return items;
    return [...items, { id: current, kind: 'missing', name: t('monitoring:src.missing', { id: current }) }];
}
